export default __webpack_public_path__ + "static/media/jodirect.104a386b.jpg";